<template>
  <div class="detail">
    <h2 class="detail-title">单据信息</h2>
    <el-form
      ref="documentForm"
      :model="ruleForm"
      :rules="rules"
      label-width="200px"
      label-suffix="："
      class="demo-ruleForm"
    >
      <el-row>
        <el-col :span="15">
          <el-form-item label="关联石化订单" prop="stockAffirmIdList">
            <template v-if="isDetail">
              <template v-for="item in ruleForm.ecAndPetroList">
                <eui-btn
                  :key="item.stockId"
                  type="link"
                  font-size="12px"
                  @click="openAffirmDialog(item)"
                >
                  {{ item.stockAffirmId ? item.stockAffirmId : item.orderNo }}
                </eui-btn>
              </template>
            </template>
            <template v-else>
              <el-input
                v-model="ruleForm.stockAffirmIdList"
                readonly
                placeholder="请选择关联石化订单"
              ></el-input>
              <div class="message">
                提示：请关联石化订单，为溯源本次生产所需的原材料采购信息。
              </div>
            </template>
          </el-form-item>
        </el-col>
        <el-col v-if="!isDetail" :span="6">
          <div class="add-btn">
            <eui-btn type="weak" @click="openStockDrawer">选择石化订单</eui-btn>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="15">
          <el-form-item
            label="采购日期"
            :prop="!isDetail ? 'purchaseDate' : ''"
          >
            <template v-if="isDetail">
              <span>{{ ruleForm.purchaseDate }}</span>
            </template>
            <template v-else>
              <el-date-picker
                v-model="ruleForm.purchaseDate"
                type="date"
                placeholder="选择日期时间"
                format="yyyy-MM-dd"
              ></el-date-picker>
            </template>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="15">
          <el-form-item
            label="供应商名称"
            :prop="!isDetail ? 'supplierCompanyName' : ''"
          >
            <template v-if="isDetail">
              <span>{{ ruleForm.supplierCompanyName }}</span>
            </template>
            <template v-else>
              <el-input
                v-model="ruleForm.supplierCompanyName"
                disabled
                placeholder="请输入供应商名称"
              ></el-input>
            </template>
          </el-form-item>
        </el-col>
        <el-col v-if="!isDetail" :span="9">
          <div class="add-btn">
            <eui-btn type="weak" @click="stockDialogVisible = true"
              >选择供应商</eui-btn
            >
            <el-tooltip
              class="item"
              effect="dark"
              content="选择历史库存下单供应商名称"
              placement="top"
            >
              <div class="icon">?</div>
            </el-tooltip>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <template v-if="isDetail">
              <span>{{ ruleForm.remark }}</span>
            </template>
            <template v-else>
              <el-input
                v-model="ruleForm.remark"
                type="textarea"
                placeholder="请输入备注信息"
                :maxlength="300"
                show-word-limit
              ></el-input>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--品类、采购合同上传、附件整合-->
    <common-upload
      ref="commonRef"
      :supplier-company-id="ruleForm.supplierCompanyId"
      :form-data="formData"
      :target-id="targetId"
      :is-detail="isDetail"
      :ai-audit-type="aiAuditType"
    />
    <!--选择石化采购意向单-->
    <StockDrawer
      v-if="stockDrawerVisible"
      :visible.sync="stockDrawerVisible"
      :select-table-data="selectTableData"
      @getPurchasePlanList="getPurchasePlanList"
    />
    <StockDialog
      :visible.sync="stockDialogVisible"
      @getSupplierInfo="getSupplierInfo"
    />

    <AffirmDialog
      :visible.sync="affirmVisible"
      :stock-id="stockId"
    ></AffirmDialog>
  </div>
</template>

<script>
import api from '@/modules/projectA/api/order';
import { epecToken } from '@/modules/projectA/utils/globalData';
import _ from 'lodash';
import StockDrawer from './StockDrawer.vue';
import StockDialog from './StockDialog.vue';
import stockAffirmDialog from '../../../order/common/stockAffirmDialog.vue';
import AffirmDialog from './AffirmDialog';
import commonUpload from '../../components/commonUpload';

export default {
  components: {
    StockDrawer,
    StockDialog,
    AffirmDialog,
    stockAffirmDialog,
    commonUpload,
  },
  props: {
    isDetail: Boolean,
    formData: {
      type: Object,
      default: () => ({
        supplierCompanyName: '',
        supplierCompanyId:0,
        remark: '',
        stockAffirmIdList: '',
        purchasePlanList: [],
        attachList: [], // 审查附件
        ecAndPetroList: [],
        purchaseDate: '',
        contractAttachList: [], // 采购合同

        oneCategoryValue: '',
        twoCategoryValue: '',
        threeCategoryValue: '',
        lbbm: '',

        aiCheckResult: '',
      }),
    },
    isOnlyView: {
      type: Boolean,
      required: false,
    },
    aiAuditType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      targetId: 0,
      ruleForm: _.cloneDeep(this.formData),
      selectTableData: [],
      rules: {
        supplierCompanyName: [
          {
            required: true,
            message: '请输入供应商名称',
            trigger: ['blur', 'change'],
          },
        ],
        purchaseDate: [
          {
            required: true,
            message: '请选择采购日期',
            trigger: ['blur', 'change'],
          },
        ],
        // stockAffirmIdList: [{required: true, message: '请选择关联石化采购意向单', trigger: ['blur', 'change']}],
      },
      uploadUrl: api.orderAttachUpload,
      headers: epecToken,
      fileIndex: 0,

      stockDrawerVisible: false,
      stockDialogVisible: false,

      affirmVisible: false,

      stockId: -1,
    };
  },
  computed: {},
  watch: {
    formData: {
      handler(newVal) {
        this.ruleForm = _.cloneDeep(newVal);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.targetId = this.$route.params.id;
    if (this.$route.query.id) {
      this.queryStockBind();
    }
  },
  methods: {
    // 编辑时 选择石化采购意向单右侧的数据
    async queryStockBind() {
      const params = {
        stockId: this.$route.query.id,
      };
      const { code, data = [], total } = await api.queryStockBind(params);
      if (code === '200') {
        this.selectTableData = data;
      }
    },
    openAffirmDialog(item) {
      const { id } = item;
      this.stockId = id;
      this.affirmVisible = true;
    },
    getSupplierInfo(supplierInfo) {
      const { supplierCompanyName, supplierCompanyId } = supplierInfo;
      this.ruleForm.supplierCompanyName = supplierCompanyName;
      this.ruleForm.supplierCompanyId = supplierCompanyId;
    },
    getPurchasePlanList(list) {
      const purchasePlanList = list.map((item) => item.id);
      this.ruleForm.purchasePlanList = purchasePlanList;
      this.ruleForm.stockAffirmIdList = list
        .map((item) => (item.stockAffirmId ? item.stockAffirmId : item.orderNo))
        .join(',');
      this.selectTableData = [...list];
      this.ruleForm.ecAndPetroList = [...list];
    },
    openStockDrawer() {
      this.stockDrawerVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm);
          /* 
            1.处理关联石化采购意向单
            2.出处理附件上传
          */
          this.$emit('documentInfo', this.ruleForm);
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
.detail {
  padding: 20px;
  background: #fff;
  .detail-title {
    margin-bottom: 20px;
    font-size: 16px;
    color: #333;
  }
}
.tooltip {
  display: inline-flex;
  align-items: center;
}
.icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 16px;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #c5c5c5;
  font-size: 12px;
  color: #c5c5c5;
  cursor: pointer;
  margin-left: 20px;
}
.add-btn {
  margin: 1.5px 0 0 10px;
}
.message {
  color: #999;
}
.tip-word {
  margin-left: 10px;
  color: #999;
}
.attach-mapper {
  display: grid;
  grid-template-columns: repeat(auto-fill, 250px);
  grid-template-rows: auto;
  column-gap: 20px;
  row-gap: 10px;
  margin-top: 10px;
  .attach-box {
    width: 250px;
    height: 60px;
    padding: 6px 10px;
    background: linear-gradient(
      90deg,
      #f5f5f5 0%,
      rgba(245, 245, 245, 0.2) 100%
    );
    .cursor-show {
      cursor: pointer;
    }
    .attach-left {
      width: 216px;
      .flex-start {
        display: flex;
        align-items: center;
      }
      .margin-t5 {
        margin-top: 5px;
      }
      .label-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        height: 20px;
        border: 1px solid #d9d9d9;
        margin-right: 6px;
        color: #666;
        font-size: 12px;
        cursor: pointer;
        background-color: #fff;
        &:hover {
          background-color: #e9f3ff;
          border-color: #2587ff;
          color: #2587ff;
        }
      }
      .choose-label {
        width: 100px;
        height: 20px;
        line-height: 18px;
        border: 1px solid #2587ff;
        color: #2587ff;
        font-size: 12px;
        text-align: center;
        cursor: pointer;
        &:hover {
          background-color: #e9f3ff;
        }
      }

      .margin-t4 {
        margin-top: 4px;
      }
    }
    .attach-right {
      margin-top: 10px;
      cursor: pointer;
    }
    .file-name {
      color: #0064c8;
      font-size: 14px;
      line-height: 1.1;
    }
  }
}
/* ::v-deep .el-input__inner,
.el-textarea__inner {
  color: #999;
} */
</style>
